(async()=>{
 const assetBase=new URL('.',document.currentScript.src);
 const root=document.querySelector('#toolcatalog');
 if(!root)return;
 const status=root.querySelector('[role=status]'),form=root.querySelector('form');
 const euro=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'});
 try{
  const tools=window.JordigiToolCatalog,cards=[],filters={};
  function select(label,values){
   const control=document.createElement('select');
   for(const value of values)control.add(new Option(value,value));
   label.append(control);return control;
  }
  for(const [key,title] of Object.entries({branch:'Branche',task:'Toepassing',goal:'Doel'})){
   const label=document.createElement('label');label.textContent=title;form.append(label);
   filters[key]=select(label,['Alle',...new Set(tools.map(tool=>tool[key]))]);
  }
  for(const tool of tools){
   const card=root.querySelector('template').content.firstElementChild.cloneNode(true);
   const image=card.querySelector('img');image.loading='eager';image.width=640;image.height=400;
   card.querySelector('small').textContent=tool.task;
   card.querySelector('h2').textContent=tool.name;
   card.querySelector('p').textContent=tool.description;
   const chooser=card.querySelector('fieldset');
   for(const [index,preset] of tool.presets.entries()){
    const label=document.createElement('label'),input=document.createElement('input');
    input.type='radio';input.name='preset-'+cards.length;input.value=String(index);input.checked=index===(tool.cover??0);
    label.append(input,document.createTextNode(preset.label));chooser.append(label);
   }
   function choose(){
    const choice=tool.presets[Number(chooser.querySelector(':checked').value)];
    image.src=new URL(choice.previewAsset,assetBase).href;image.alt=tool.name+' · '+choice.label;
    const url=new URL(choice.url,location.origin);
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    card.querySelector('.cta').href=url.href;
    card.querySelector('strong').textContent=euro.format(choice.price)+' basisprijs';
   }
   chooser.onchange=choose;choose();cards.push([card,tool]);
   root.querySelector('.grid').append(card);
  }
  function filter(){
   let count=0;
   for(const [card,tool] of cards){
    card.hidden=Object.entries(filters).some(([key,control])=>control.value!=='Alle'&&tool[key]!==control.value&&!(key==='branch'&&tool.branch==='Branchebreed'));
    if(!card.hidden)count++;
   }
   status.textContent=count===1?'1 tool':count+' tools';
  }
  form.onchange=filter;filter();
 }catch{status.textContent='De catalogus kon niet laden. Ververs de pagina om het opnieuw te proberen.'}
})();

